import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import { AuthProvider } from "./features/auth/auth-context.js";
import { OrganizationProvider } from "./features/organizations/organization-context.js";
import { WhatsAppWorkspacePhoneProvider } from "./features/whatsapp/whatsapp-workspace-phone-context.js";
import "./i18n/index.js";
import "./styles/globals.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("The #root element is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <OrganizationProvider>
          <WhatsAppWorkspacePhoneProvider>
            <App />
          </WhatsAppWorkspacePhoneProvider>
        </OrganizationProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
